module.exports = __webpack_public_path__ + "img/3.f52d4ee4.jpg";